import React from "react";
import * as styles from "./styles.module.scss";

const PollItem = ({
  itemName,
  percentage,
  gradientStartColor,
  gradientEndColor,
  animate
}) => (
  <div className={styles.container}>
    <div
      className={styles.progressBar}
      style={{
        background: `linear-gradient(90deg, ${gradientStartColor}, ${gradientEndColor})`,
        width: `${animate ? percentage : 0}%`
      }}
    />
    <div className={styles.text}>
      <div className="h4">{itemName}</div>
      <div className="b1">{percentage}%</div>
    </div>
  </div>
);

export default PollItem;
